export default "__VITE_ASSET__Hxwua5lt__"